import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password/forgot-password.component';
import {TranslateModule} from "@ngx-translate/core";
import {ResetPasswordComponent} from "./forgot-password/reset-password/reset-password.component";
import { TwoFactorComponent } from './two-factor/two-factor.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import {SharedModule} from "../../shared/shared.module";

@NgModule({
  declarations: [LoginComponent,TwoFactorComponent, ForgotPasswordComponent, ResetPasswordComponent],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        TranslateModule,
        NgxCaptchaModule,
        SharedModule
    ],
  exports: [LoginComponent]
})
export class AuthModule {
}
